import { useState } from 'react';

import { Radio } from 'antd';
import {
  Button,
  ButtonType,
  CaretDownOutlined,
  Checkbox,
  Column,
  Popover,
  PopoverPlacement,
  Row,
  Space,
  Text,
} from 'farmhub-ui-core';

import { theme } from 'styled';

import { SettingInfoVisibleInterface } from './interfaces';
import { WrapperPopover } from './styles';

type SettingInfoVisibleProps = {
  title: string;
  data: SettingInfoVisibleInterface[];
  values: any;
  onChangeSetting: (e: any) => void;
  onAfterChanged?: () => void;
};

const SettingInfoVisible = ({
  title,
  data,
  values,
  onChangeSetting,
  onAfterChanged,
}: SettingInfoVisibleProps): JSX.Element => {
  const [visiblePopover, setVisiblePopover] = useState(false);
  const [changed, setChanged] = useState(false);

  const handChangeVisiblePopover = (visible: boolean): void => {
    if (!visible && changed) {
      onAfterChanged && onAfterChanged();
      setChanged(false);
    }
    setVisiblePopover(visible);
  };

  const handleChangeSetting = (e: any): void => {
    onChangeSetting(e);
    setChanged(true);
  };

  const popoverContent = (
    <WrapperPopover>
      {data.map(item => {
        if (item.type === 'radio') {
          let radioValues = Object.keys(item.name).find(key => values[key]);
          if (!radioValues) {
            radioValues = Object.keys(item.name)[0];
          }

          return (
            <>
              {item.title && item.title !== '' && (
                <>
                  <Text color="primary">{item.title}:</Text>
                  <Space height={8} />
                </>
              )}

              <Radio.Group
                value={radioValues}
                onChange={e => {
                  handleChangeSetting({
                    ...Object.keys(item.name).reduce((res, name) => {
                      return { ...res, [name]: false };
                    }, {}),
                    [e.target.value]: true,
                  });
                }}
              >
                <Column>
                  {Object.keys(item.name).map(key => (
                    <Radio value={key}>
                      <Text color="secondary">{item.name[key]}</Text>
                    </Radio>
                  ))}
                </Column>
              </Radio.Group>
              <Space height={4} />
            </>
          );
        }

        return (
          <>
            {item.title && item.title !== '' && (
              <>
                <Text color="primary">{item.title}:</Text>
                <Space height={8} />
              </>
            )}
            {Object.keys(item.name).map(key => (
              <>
                <Checkbox
                  checked={values[key]}
                  styles={{ margin: '0px !important' }}
                  onChange={e =>
                    handleChangeSetting({ [key]: e.target.checked })
                  }
                >
                  <Text color="secondary">{item.name[key]}</Text>
                </Checkbox>
                <Space height={4} />
              </>
            ))}
          </>
        );
      })}
    </WrapperPopover>
  );

  return (
    <Popover
      containerId="container"
      content={popoverContent}
      placement={PopoverPlacement.BottomLeft}
      trigger="click"
      visible={visiblePopover}
      onVisibleChange={handChangeVisiblePopover}
    >
      <Button
        height={theme.button.height.sm}
        type={ButtonType.Default}
        width="160px"
      >
        <Row justifyContent="space-between" styles={{ gap: 6 }}>
          <Text color="primary">{title}</Text>
          <CaretDownOutlined color="#BFBFBF" />
        </Row>
      </Button>
    </Popover>
  );
};

export default SettingInfoVisible;
